<template>
  <div>
    <VTableLocal
      v-if="displayedAnalysisRequests.length"
      :items="displayedAnalysisRequests"
      :headers="tableHeaders"
      data-cy="cyWoArTable"
      disablePagination
    >
      <template #item.samples="{ item }">
        <List :items="item.samples" />
      </template>
      <template #item.analysisTypes="{ item }">
        <List :items="item.analysisTypes" />
      </template>
      <template v-slot:item.delete="{item }">
        <v-btn
          :disabled="item.status === status.COMPLETED || item.status === status.INTREATMENT"
          depressed
          color="primary"
          data-cy="cyDeleteAr"
          @click="deleteAnalysisRequest(item)"
        >
          {{ $t('analysisRequests.labels.template.delete') }}
        </v-btn>
      </template>
    </VTableLocal>
    <v-container v-else>
      <v-row
        align="center"
        justify="center"
      >
        <span class="title">
          {{ $t('analysisRequests.labels.emptySearch') }}
        </span>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import List from '@/components/shared/content-views/slots/List';
import analysisRequestStatus from '@/constants/analysisRequestStatus';

export default {
    components: {
        VTableLocal,
        List,
    },
    props: {
        tree: {
            type: Array,
            default: () => [],
        },
        analysisTypes: {
            type: Array,
            default: () => [],
        },
        workOrderId: {
            type: String,
            default: '',
        },
    },

    computed: {
        ...mapGetters([
            'userLang',
            'analysisRequestsList',
        ]),
        displayedAnalysisRequests() {
            if (this.analysisRequestsList) {
                return this.analysisRequestsList.map(({
                    type,
                    samples = [],
                    component = {},
                    analysisTypes = [],
                    ...props
                }) => {
                    const node = this.findNode(this.tree, component.id) || {};
                    return {
                        ...props,
                        type: this.$t(`sampleTypes.${type.charAt(0).toLowerCase()}${type.substring(1)}`),
                        samples: samples.map(sample => sample.identification),
                        component: node.name,
                        analysisTypes: analysisTypes.map(analysisType => analysisType.name),
                    };
                });
            }
            return [];
        },

        tableHeaders() {
            return [
                'component',
                'type',
                'requestNumber',
                'analysisTypes',
                'samples',
                'delete',
            ].map(header => ({
                text: this.$t(`analysisRequests.labels.${header}`),
                value: header,
            }));
        },
        status() {
            const status = {};
            Object.keys(analysisRequestStatus).forEach(key => {
                status[key] = key;
            });
            return status;
        },
    },
    methods: {
        ...mapActions({
            reloadWorkOrder: 'getWorkOrderInfo',
        }),
        findNode(tree = [], ref) {
            const response = tree.map(node => (node.ref === ref ? node : this.findNode(node.children, ref)));
            return response.find(a => a || null);
        },
        async deleteAnalysisRequest(item) {
            await this.$rq.removeAnalysisRequest(item.id);
            this.$toasted.global.toast_success({
                message: this.$t('msg.analysisRemoved', { data: item.requestNumber }),
            });
            await this.reloadWorkOrder(this.workOrderId);
        },
    },
};
</script>
